import React from 'react'
import classNames from 'classnames'
import { ControlProps, getControlParts } from './Control'
import { useIMask } from 'react-imask'

import './PhoneInput.scss'

export interface PhoneInputProps extends ControlProps {
	phoneValue: string
	extValue: string
	onChange: (phone: string, ext: string) => void
}

export function PhoneInput(props: PhoneInputProps) {

	const phoneMask = useIMask({ mask: '(000)000-0000' });
	const extMask = useIMask({ mask: '00000' })

	// feels like a hack.  TODO: find out how to set initial mask values
	React.useEffect(() => {
		phoneMask.setValue(props.phoneValue)
		extMask.setValue(props.extValue)
	}, [])

	const inputClass = classNames('input', { 'is-danger': props.errorMessage })

	const controlProps = getControlParts(props)

	const phoneChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
		props.onChange(phoneMask.unmaskedValue, extMask.unmaskedValue)
	}

	const extChangeHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
		props.onChange(phoneMask.unmaskedValue, extMask.unmaskedValue)
	}

	const inputControl = (
		<div className='phone-input-component field'>
			{controlProps.labelElement}
			<div className='field has-addons'>
				<div className='phone control'>
					<input ref={phoneMask.ref as React.LegacyRef<HTMLInputElement>} id={controlProps.inputId} className={inputClass} type='tel' onInput={phoneChangeHandler} disabled={props.disabled} />
				</div>
				<p className='control'>
					<a className="button is-static">
						X
					</a>
				</p>
				<div className='ext control'>
					<input ref={extMask.ref as React.LegacyRef<HTMLInputElement>} className={inputClass} type='text' onInput={extChangeHandler} disabled={props.disabled} />
				</div>
			</div>
			{controlProps.helpTextElement}
		</div>
	)

	return props.isInColumn ? <div className='column'>{inputControl}</div> : inputControl
}

export default PhoneInput
